import { useState, useEffect } from 'react'
import { useAdmin } from '../context/AdminContext'
import { createAdminApi, DbPrefabDetail } from '../services/adminApi'
import styles from './PrefabsPage.module.css'

export default function PrefabsPage() {
  const { apiKey } = useAdmin()

  const [prefabs, setPrefabs] = useState<DbPrefabDetail[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [creating, setCreating] = useState(false)
  const [newName, setNewName] = useState('')
  const [createError, setCreateError] = useState('')

  useEffect(() => {
    const api = createAdminApi(() => apiKey)
    setLoading(true)
    setError('')
    api.listDbPrefabs()
      .then(setPrefabs)
      .catch(e => setError(e instanceof Error ? e.message : String(e)))
      .finally(() => setLoading(false))
  }, [apiKey])

  async function handleCreate() {
    if (!newName.trim()) return
    const api = createAdminApi(() => apiKey)
    setCreateError('')
    try {
      const t = await api.createDbPrefab(newName.trim(), '', '', '')
      window.location.hash = '#prefabs/' + t.id
    } catch (e) {
      setCreateError(e instanceof Error ? e.message : String(e))
    }
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1>Prefabs</h1>
        <div className={styles.headerStats}>
          {!loading && <span className={styles.statPill}>{prefabs.length} in DB</span>}
          <button className={styles.createBtn} onClick={() => { setCreating(p => !p); setCreateError('') }}>
            + New Prefab
          </button>
        </div>
      </header>

      {creating && (
        <div className={styles.createBar}>
          <input
            className={styles.createInput}
            placeholder="Prefab name (unique ID)"
            value={newName}
            onChange={e => setNewName(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') handleCreate() }}
            autoFocus
          />
          <button className={styles.saveBtn} onClick={handleCreate}>Create</button>
          <button className={styles.cancelBtn} onClick={() => { setCreating(false); setNewName(''); setCreateError('') }}>Cancel</button>
          {createError && <span className={styles.saveError}>{createError}</span>}
        </div>
      )}

      {error && <div className={styles.error}>{error}</div>}

      <div className={styles.content}>
        {loading ? (
          <p className={styles.empty}>Loading…</p>
        ) : prefabs.length === 0 ? (
          <p className={styles.empty}>No prefabs in DB. Create one above or configure via the Admin page.</p>
        ) : (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Phrases</th>
                <th>Not For</th>
                <th>Alternate</th>
                <th>Stories</th>
                <th>Updated</th>
              </tr>
            </thead>
            <tbody>
              {prefabs.map(t => (
                <tr
                  key={t.id}
                  className={styles.row}
                  onClick={() => { window.location.hash = '#prefabs/' + t.id }}
                >
                  <td className={styles.nameCell}>
                    <a href={'#prefabs/' + t.id} onClick={e => e.stopPropagation()}>
                      {t.name}
                    </a>
                  </td>
                  <td>{t.phrases ? (t.phrases.length > 80 ? t.phrases.slice(0, 80) + '…' : t.phrases) : '—'}</td>
                  <td>{t.notFor || '—'}</td>
                  <td>{t.alternate || '—'}</td>
                  <td>{t.stories.length} {t.stories.length === 1 ? 'story' : 'stories'}</td>
                  <td>{new Date(t.updatedAt).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}
